export default function WhyImportant() {
  const benefits = [
    {
      icon: 'ri-search-line',
      title: 'Parempi näkyvyys Googlessa',
      description: 'Google-arvostelut parantavat hakutuloksissa näkyvyyttäsi ja nostavat sijoitustasi paikallishauissa.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Lisää luottamusta',
      description: '90% kuluttajista lukee arvostelut ennen ostopäätöstä. Positiiviset arvostelut lisäävät luottamusta.'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Kasvata myyntiä',
      description: 'Yritykset, joilla on paljon positiivisia arvosteluja, saavat keskimäärin 31% enemmän liikevaihtoa.'
    },
    {
      icon: 'ri-star-line',
      title: 'Kilpailuetu',
      description: 'Erotu kilpailijoistasi ja näytä asiakkaillesi, että olet luotettava ja laadukas kumppani.'
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#3B82F6]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#1E3A8A]/5 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-12 md:mb-16 animate-[fadeInUp_0.8s_ease-out]">
          <div className="inline-block bg-gradient-to-r from-[#3B82F6] to-[#1E3A8A] text-white px-5 py-2 rounded-full text-sm font-semibold mb-4 shadow-lg">
            Miksi tämä on tärkeää?
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 font-inter">
            Google-arvostelut ovat yrityksesi menestyksen avain
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Positiiviset arvostelut eivät ole vain mukava lisä – ne ovat välttämättömyys modernissa liiketoiminnassa
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {benefits.map((benefit, idx) => (
            <div 
              key={idx} 
              className="bg-white rounded-2xl md:rounded-[2rem] p-6 md:p-10 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100 hover:border-[#3B82F6]/30 group animate-[fadeInUp_0.8s_ease-out]"
              style={{ animationDelay: `${idx * 0.15}s` }}
            >
              <div className="w-14 h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#3B82F6] to-[#1E3A8A] rounded-2xl flex items-center justify-center text-white text-2xl md:text-3xl mb-5 md:mb-6 shadow-xl group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                <i className={benefit.icon}></i>
              </div>
              
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-4 group-hover:text-[#1E3A8A] transition-colors duration-300">
                {benefit.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed text-base md:text-lg">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 md:mt-16 bg-gradient-to-r from-[#1E3A8A] to-[#3B82F6] rounded-2xl md:rounded-[2rem] p-6 md:p-10 text-white shadow-2xl animate-[fadeInUp_0.8s_ease-out_0.6s_both] hover:shadow-[0_25px_50px_-12px_rgba(30,58,138,0.5)] transition-all duration-500">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 text-center">
            <div className="group">
              <div className="text-4xl md:text-5xl font-bold mb-2 group-hover:scale-110 transition-transform duration-300">90%</div>
              <div className="text-white/90 text-base md:text-lg">kuluttajista lukee arvostelut</div>
            </div>
            <div className="group">
              <div className="text-4xl md:text-5xl font-bold mb-2 group-hover:scale-110 transition-transform duration-300">31%</div>
              <div className="text-white/90 text-base md:text-lg">enemmän liikevaihtoa</div>
            </div>
            <div className="group">
              <div className="text-4xl md:text-5xl font-bold mb-2 group-hover:scale-110 transition-transform duration-300">4.5★</div>
              <div className="text-white/90 text-base md:text-lg">keskimääräinen arvosana</div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
}